import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./Menu";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export default function PresupuestosIngresos(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  let navigate = useNavigate();

  const exportColumns = [
    { title: "ID Presupuesto", dataKey: "id_presupuesto" },
    { title: "Concepto", dataKey: "concepto" },
    { title: "Presupuestado", dataKey: "importe" },
  ];

  const [presupuesto, guardarPresupuesto] = useState(null);
  const [visible, setVisible] = useState(false);
  const [detalle, guardarDetalle] = useState(null);
  const [fecha, guardarFecha] = useState(null);
  const [periodo1, guardarPeriodo1] = useState(null);
  const [periodo2, guardarPeriodo2] = useState(null);
  const [periodo3, guardarPeriodo3] = useState(null);
  const toast = useRef(null);

  let { sector } = useParams();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    statusAcceso2,
    conceptos,
    conceptosSector,
    conceptosSectorPeriodo,
    periodoPresupuesto,
    presupuestoIngresos,
    obtenerConceptos,
    obtenerPresupuestoIngresos,
    obtenerConceptosSectorPeriodo,
    obtenerAcceso,
    obtenerAcceso2,
    agregarConceptoPresupuesto,
    actualizarConceptoPresupuesto,
    obtenerPeriodoPresupuesto,
    actualizarPeriodoPresupuesto,
    guardarPeriodoPresupuesto,
    eliminarConceptoPresupuesto,
    obtenerPresupuestoIngresosUnificado,
    actualizarPresupuestoUnificado,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      if (sector && sector === "administracion") {
        obtenerAcceso({
          usuarioId: state.usuario.id,
          layout: "PresupuestoIngresosAdministracion",
        });
      }
      if (sector && sector === "cobranzas") {
        obtenerAcceso({
          usuarioId: state.usuario.id,
          layout: "PresupuestoIngresosCobranzas",
        });
      }
    }
  }, [state]);

  useEffect(() => {
    if (sector) {
      obtenerPeriodoPresupuesto();
      obtenerPresupuestoIngresos({ sector: sector });
    }
  }, [sector]);

  useEffect(() => {
    if (periodoPresupuesto) {
      obtenerPresupuestoIngresosUnificado({
        sector, 
        periodo: periodoPresupuesto.periodo,
      });
    }
  }, [periodoPresupuesto]);

  const datosAplanados = conceptosSector.map((item) => ({
    "conceptos.id_presupuesto": item.conceptos?.id_presupuesto,
    "conceptos.nombre": item.conceptos?.nombre,
    importe: Number(item.importe).toLocaleString("en-US", {
      minimumFractionDigits: 2,
    }),
  }));

  function calcularPeriodoAnterior(periodo) {
    // 1. Separar el mes y el año del string (ej: "01/26")
    const [mesStr, añoStr] = periodo.split("/");

    // 2. Crear un objeto Date (usamos el día 1 por defecto)
    // Nota: El año se suma a 2000 para obtener el año completo (ej: 2026)
    // El mes en JS es base 0 (0 = enero), por eso restamos 1
    let fecha = new Date(parseInt("20" + añoStr), parseInt(mesStr) - 1, 1);

    // 3. Restar un mes
    fecha.setMonth(fecha.getMonth() - 1);

    // 4. Formatear de vuelta a MM/YY
    let mesAnterior = (fecha.getMonth() + 1).toString().padStart(2, "0");
    let añoAnterior = fecha.getFullYear().toString().slice(-2);

    return `${mesAnterior}/${añoAnterior}`;
  }

  const editClick = (e) => {
    if (selectedRow) {
      selectedRow.diferidoreal = selectedRow.diferidoreal.replaceAll(",", "");
      selectedRow.diferidoperiodo = selectedRow.diferidoperiodo.replaceAll(",", "");
      selectedRow.facturacionreal = selectedRow.facturacionreal.replaceAll(",", "");
      selectedRow.facturacionperiodo = selectedRow.facturacionperiodo.replaceAll(",", "");
      guardarPresupuesto(selectedRow);
      setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un concepto.",
        life: 3000,
      });
    }
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar

    // Llamar al context
    if (selectedRow) {
      actualizarPresupuestoUnificado({
        sector,
        presupuesto,
        periodo: periodoPresupuesto.periodo,
      });
    } else {
    }
    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerPresupuestoIngresosUnificado({
        sector,
        periodo: periodoPresupuesto.periodo,
      });
    }, 2000);
    //exitClick();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Presupuesto",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const habilitadoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.habilitado}></Checkbox>
      </Fragment>
    );
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.setFontSize(12);
        doc.text(
          `Listado de conceptos de ${sector} del período ${periodoPresupuesto.periodo}`,
          30,
          8,
        );

        doc.setFontSize(10);
        doc.autoTable(
          exportColumns,
          conceptosSector.filter((fila) => {
            // Condición para mantener la fila (ej: no incluir si es una fila de totales o un ID específico)
            return Number(fila.importe) !== 0;
          }),
          {
            columnStyles: {
              2: {
                halign: "right",
              },
            },
            didParseCell: (data) => {
              if (data.cell && data.cell.section === "head") {
                switch (data.cell.raw) {
                  case "Presupuestado":
                    data.cell.styles.halign = "right";
                    break;
                  default:
                    data.cell.styles.halign = "left";
                    break;
                }
              }
            },
          },
        );
        window.open(doc.output("bloburl"));
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(conceptos);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "conceptos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag
          value={
            periodoPresupuesto && sector
              ? "Presupuesto Ingresos Período " +
                periodoPresupuesto.periodo +
                " (" +
                sector.toUpperCase() +
                ")"
              : "Presupuesto"
          }
        ></Tag>
      </div>
    </Fragment>
  );

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Presupuesto Ingresos"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(presupuestoIngresos);
  //console.log(conceptos);

  return (
    <Fragment>
      <Menu />
      <ConfirmDialog />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{ align: "center", margin: "1em" }}
          >
            <Button
              icon="pi pi-pencil"
              tooltip="Editar"
              className="p-button-rounded p-button-danger"
              style={{ marginLeft: "1em" }}
              disabled={
                periodoPresupuesto && !periodoPresupuesto.editarIngresos
              }
              onClick={editClick}
            />
            <Button
              icon="pi pi-times"
              tooltip="Cerrar"
              className="p-button-rounded p-button-primary"
              style={{ marginLeft: "1em" }}
              onClick={exitClick}
            />
            <div className="datatable-responsive-demo">
              <div className="card">
                <Tooltip target=".export-buttons>button" position="bottom" />
                <DataTable
                  value={presupuestoIngresos}
                  selection={selectedRow}
                  onSelectionChange={(e) => 
                    setSelectedRow(e.value)
                  }
                  selectionMode="single"
                  dataKey="presupuestoingresoid"
                  header={header}
                  className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                  style={{ fontSize: "small", marginTop: "1vw" }}
                  globalFilter={globalFilter}
                  emptyMessage="No hay datos."
                  paginator
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                  //paginatorLeft={paginatorLeft}
                  //paginatorRight={paginatorRight}
                >
                  <Column
                    field="presupuestoingresoid"
                    header="Id"
                    //body={idTemplate}
                    sortable
                    //style={{display: "none"}}
                  ></Column>
                  <Column
                    field="presupuestoingreso"
                    header="Concepto"
                    //body={descripcionTemplate}
                    sortable
                  ></Column>
                  {sector === "cobranzas" ?
                  <Column
                    field="diferidoreal"
                    header="Diferido Real"
                    sortable
                  ></Column>
                  : null }
                  {sector === "cobranzas" ?
                  <Column
                    field="diferidoperiodo"
                    header="Diferido Período"
                    sortable
                  ></Column>
                  : null }
                  <Column
                    field="facturacionreal"
                    header="Facturación Real"
                    sortable
                  ></Column>
                  {sector === "cobranzas" ?
                  <Column
                    field="facturacionperiodo"
                    header="Facturación Período"
                    sortable
                  ></Column>
                  : null }
                  <Column field="total" header="Total" sortable></Column>
                </DataTable>
              </div>
            </div>
          </Grid>

          <Dialog
            header={renderHeader()}
            visible={visible}
            closable={false}
            footer={renderFooter()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "50vw", paddingBottom: "0" }}
            position="center"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              { sector === "cobranzas" ?
              <Fragment>
              <Grid item xs={12} md={6}>
                <label
                  style={{
                    marginLeft: "1vw",
                    fontSize: "medium",
                  }}
                  htmlFor="diferidoreal"
                >
                  Diferido Real:
                </label>
                <InputNumber
                  inputId="diferidoreal"
                  value={presupuesto ? presupuesto.diferidoreal : null}
                  onChange={(e) => {
                    if (e.value) {
                      guardarPresupuesto({
                        ...presupuesto,
                        diferidoreal: e.value,
                      });
                    } else {
                      guardarPresupuesto({
                        ...presupuesto,
                        diferidoreal: null,
                      });
                    }
                  }}
                  size={12}
                  mode="decimal"
                  locale="en-US"
                  minFractionDigits={2}
                  style={{
                    marginLeft: "0.7vw",
                    marginTop: "0.8vw",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <label
                  style={{
                    marginLeft: "1vw",
                    fontSize: "medium",
                  }}
                  htmlFor="diferidoperiodo"
                >
                  Diferido Período:
                </label>
                <InputNumber
                  inputId="diferidoperiodo"
                  value={presupuesto ? presupuesto.diferidoperiodo : null}
                  onChange={(e) => {
                    if (e.value) {
                      guardarPresupuesto({
                        ...presupuesto,
                        diferidoperiodo: e.value,
                      });
                    } else {
                      guardarPresupuesto({
                        ...presupuesto,
                        diferidoperiodo: null,
                      });
                    }
                  }}
                  size={12}
                  mode="decimal"
                  locale="en-US"
                  minFractionDigits={2}
                  style={{
                    marginLeft: "0.7vw",
                    marginTop: "0.8vw",
                  }}
                />
              </Grid>
              </Fragment>
              : null }

              <Grid item xs={12} md={6}>
                <label
                  style={{
                    marginLeft: "1vw",
                    fontSize: "medium",
                  }}
                  htmlFor="facturacionreal"
                >
                  Facturación Real:
                </label>
                <InputNumber
                  inputId="facturacionreal"
                  value={presupuesto ? presupuesto.facturacionreal : null}
                  onChange={(e) => {
                    if (e.value) {
                      guardarPresupuesto({
                        ...presupuesto,
                        facturacionreal: e.value,
                      });
                    } else {
                      guardarPresupuesto({
                        ...presupuesto,
                        facturacionreal: null,
                      });
                    }
                  }}
                  size={12}
                  mode="decimal"
                  locale="en-US"
                  minFractionDigits={2}
                  style={{
                    marginLeft: "0.7vw",
                    marginTop: "0.8vw",
                  }}
                />
              </Grid>
              { sector === "cobranzas" ?
               <Fragment>
                <Grid item xs={12} md={6}>
                <label
                  style={{
                    marginLeft: "1vw",
                    fontSize: "medium",
                  }}
                  htmlFor="facturacionperiodo"
                >
                  Facturación Período:
                </label>
                <InputNumber
                  inputId="facturacionperiodo"
                  value={presupuesto ? presupuesto.facturacionperiodo : null}
                  onChange={(e) => {
                    if (e.value) {
                      guardarPresupuesto({
                        ...presupuesto,
                        facturacionperiodo: e.value,
                      });
                    } else {
                      guardarPresupuesto({
                        ...presupuesto,
                        facturacionperiodo: null,
                      });
                    }
                  }}
                  size={12}
                  mode="decimal"
                  locale="en-US"
                  minFractionDigits={2}
                  style={{
                    marginLeft: "0.7vw",
                    marginTop: "0.8vw",
                  }}
                />
              </Grid>
              </Fragment> 
              : null }
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
